import type { MutationUpdaterFn } from '@apollo/client';

import type * as Schema from 'src/types/graphql';

export const generateUpdateProfileVisibilityOptimisticResponse =
  (_id: string) =>
  ({ profileVisibility }: Schema.UpdateProfileVisibilityMutationVariables) => ({
    __typename: 'Mutation',
    updateProfileVisibility: {
      __typename: 'UpdateProfileVisibilityPayload',
      viewer: {
        __typename: 'Candidate',
        _id,
        profileVisibility: {
          __typename: 'ProfileVisibility',
          level: profileVisibility.level,
        },
      },
    },
  });

export const updateCacheUpdateProfileVisibility: MutationUpdaterFn<
  Schema.UpdateProfileVisibilityMutation
> = (cache, { data }) => {
  const _id = data?.updateProfileVisibility?.viewer?._id;

  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      profileVisibility: () =>
        data?.updateProfileVisibility?.viewer?.profileVisibility || null,
    },
  });
};
